<template>
  <a class="btn btn-primary"
  :href="link ? link : '#'">
    <slot></slot>
  </a>
</template>

<script>

export default {
  name: "CustomButton",
  components: {
  },
  props: [
      // "backgroundColour",
      // "textColour",
      "link"
  ],
};
</script>

<style lang="scss" scoped>
</style>
